<button [type]="type()" [disabled]="disabled()" [class]="classes()" [attr.data-active]="active()">
  <ng-content></ng-content>
</button>
